import { render, staticRenderFns } from "./RecordCollection.vue?vue&type=template&id=5232731d&scoped=true&"
import script from "./RecordCollection.vue?vue&type=script&lang=js&"
export * from "./RecordCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232731d",
  null
  
)

export default component.exports